export enum SortOperators {
  ASC = 'ASC',
  DESC = 'DESC'
}
